import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RunsPage } from "@/features/runs/RunsPage";

const search = z.object({
  status: z.enum(["all", "failed", "running", "succeeded", "skipped"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/automations/runs")({
  validateSearch: search,
  component: () => <RunsPage search={Route.useSearch()} />,
});
